/**
 * Side panel feature Redux key.
 */
export const SIDE_PANEL_FEATURE_KEY = 'features/side-panel';
/**
 * Top-level side panel application tab ids.
 */
export var SidePanelTabId;
(function (SidePanelTabId) {
    SidePanelTabId["AI_NOTES"] = "aiNotes";
    SidePanelTabId["CHAT"] = "chat";
    SidePanelTabId["CLOSED_CAPTIONS"] = "closedCaptions";
    SidePanelTabId["CUSTOM_PANEL"] = "customPanel";
    SidePanelTabId["FILE_SHARING"] = "fileSharing";
    SidePanelTabId["PARTICIPANTS"] = "participants";
    SidePanelTabId["POLLS"] = "polls";
})(SidePanelTabId || (SidePanelTabId = {}));
/**
 * Default docked side panel width in pixels.
 */
export const DEFAULT_SIDE_PANEL_WIDTH = 315;
/**
 * Minimum docked side panel width in pixels.
 */
export const MIN_SIDE_PANEL_WIDTH = 280;
/**
 * Drag handle visual width in pixels.
 */
export const SIDE_PANEL_DRAG_HANDLE_WIDTH = 9;
/**
 * Drag handle visual height in pixels.
 */
export const SIDE_PANEL_DRAG_HANDLE_HEIGHT = 100;
/**
 * Touch hit area for the drag handle.
 */
export const SIDE_PANEL_TOUCH_HANDLE_SIZE = 44;
/**
 * Offset from the panel edge for the drag handle.
 */
export const SIDE_PANEL_DRAG_HANDLE_OFFSET = 4;
/**
 * Default floating window width in pixels.
 */
export const DEFAULT_FLOATING_WIDTH = 360;
/**
 * Default floating window height in pixels.
 */
export const DEFAULT_FLOATING_HEIGHT = 520;
/**
 * Default floating window top offset in pixels.
 */
export const DEFAULT_FLOATING_TOP = 72;
/**
 * Base z-index for floating side panel windows.
 */
export const FLOATING_Z_INDEX_BASE = 400;
/**
 * Viewport width at or below which pop-out is disabled.
 */
export const SIDE_PANEL_POPOUT_MIN_WIDTH = 580;
/**
 * 手机端底部抽屉高度（约占屏下 3/4，顶部仍露出会议画面）。
 */
export const SIDE_PANEL_MOBILE_DRAWER_HEIGHT = '75dvh';
/**
 * 手机端底部抽屉顶角圆角（像素）。
 */
export const SIDE_PANEL_MOBILE_DRAWER_RADIUS_PX = 16;
/**
 * 底部抽屉拖动手柄上下内边距（像素）。
 * 不用 theme.spacing(0.5)：当前主题 spacing 为数组时不支持非整数步长。
 */
export const SIDE_PANEL_MOBILE_DRAWER_HANDLE_PADDING_TOP_PX = 8;
export const SIDE_PANEL_MOBILE_DRAWER_HANDLE_PADDING_BOTTOM_PX = 4;
/**
 * 手机端底部抽屉顶部拖条宽度（像素）。
 */
export const SIDE_PANEL_MOBILE_DRAWER_HANDLE_WIDTH_PX = 36;
/**
 * 手机端底部抽屉顶部拖条高度（像素）。
 */
export const SIDE_PANEL_MOBILE_DRAWER_HANDLE_HEIGHT_PX = 4;
/**
 * 手机端底部抽屉遮罩不透明度。
 */
export const SIDE_PANEL_MOBILE_DRAWER_BACKDROP_OPACITY = 0.45;
/**
 * 手机端底部抽屉层叠顺序（高于侧栏 dock，低于部分全局弹层）。
 */
export const SIDE_PANEL_MOBILE_DRAWER_Z_INDEX = 302;
